import { useQueryClient } from '@tanstack/react-query';
import { components } from 'src/generated/v1';
import { $api } from './api';
import { invalidateProductQueries, useProduct } from './productsNew';

export type QualityCheck = components['schemas']['QualityCheck'];
export type QualityCheckIn = components['schemas']['QualityCheckIn'];
export type QualityCheckUpdateIn = components['schemas']['QualityCheckUpdateIn'];

function invalidate(queryClient: ReturnType<typeof useQueryClient>) {
  invalidateProductQueries(queryClient);
}

export const useProductQualityChecks = (productId: number) => {
  const { product, isLoading } = useProduct(productId);

  return {
    qualityChecks: product?.quality_checks ?? [],
    isLoading,
  };
};

export const useQualityCheckMutations = () => {
  const queryClient = useQueryClient();

  const createMutation = $api.useMutation('post', '/products/{product_id}/quality_checks/', {
    onSuccess() {
      invalidate(queryClient);
    },
  });

  const deleteMutation = $api.useMutation('delete', '/products/quality_checks/{quality_check_id}', {
    onSuccess() {
      invalidate(queryClient);
    },
  });

  const updateMutation = $api.useMutation('put', '/products/quality_checks/{quality_check_id}', {
    onSuccess() {
      invalidate(queryClient);
    },
  });

  return {
    createQualityCheck: createMutation.mutate,
    createQualityCheckAsync: createMutation.mutateAsync,
    deleteQualityCheck: deleteMutation.mutate,
    deleteQualityCheckAsync: deleteMutation.mutateAsync,
    updateQualityCheck: updateMutation.mutate,
    updateQualityCheckAsync: updateMutation.mutateAsync,
    isCreating: createMutation.isPending,
    isDeleting: deleteMutation.isPending,
    isUpdating: updateMutation.isPending,
    createError: createMutation.error,
    deleteError: deleteMutation.error,
    updateError: updateMutation.error,
  };
};
